import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollectionHandle } from '@adornis/baseql/server/collections.js';
import { publishFilter } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { WorkshopAttendance } from '@chancenwerk/workshops/entities/WorkshopAttendance.js';
import { WorkshopFilter } from '@chancenwerk/workshops/entities/WorkshopFilter.js';
import { catchError, from, of, switchMap } from 'rxjs';

export const subscribeWorkshopAttendanceSimple = registerSubscription({
  type: () => [WorkshopAttendance],
  operationName: 'subscribeWorkshopAttendanceSimple',
  resolve: (skip: number, limit: number, filter: WorkshopFilter) => {
    return (gqlFields: BaseQLSelectionSet<WorkshopAttendance>) => {
      const selector = {
        _class: WorkshopAttendance._class,
        ...filter.getMongoFilter(),
      };
      const handle = getCollectionHandle<WorkshopAttendance>(WorkshopAttendance._collectionName);
      return from(publishFilter(WorkshopAttendance._class)).pipe(
        switchMap(publishFilter => {
          return handle.watchQuery(publishFilter ? { $and: [publishFilter, selector] } : selector, {
            skip,
            limit,
          });
        }),
        catchError(e => {
          return of([] as WorkshopAttendance[]);
        }),
      );
    };
  },
  params: [
    {
      name: 'skip',
      type: () => Int,
    },
    {
      name: 'limit',
      type: () => Int,
    },
    {
      name: 'filter',
      type: () => WorkshopFilter,
    },
  ],
});
